import React from 'react';
export function Footer() {
  return <footer className="relative py-12 overflow-hidden" data-id="element-41">
      {/* Solid gradient background for consistency across all pages */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900 to-slate-900/95" data-id="element-42"></div>
      {/* Ambient lighting effects - subtle and blended */}
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-cyan-500/8 rounded-full blur-3xl" data-id="element-43"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-fuchsia-500/8 rounded-full blur-3xl" data-id="element-44"></div>
      <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-purple-500/6 rounded-full blur-3xl" data-id="element-45"></div>
      {/* Top gradient separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-fuchsia-500/20 to-transparent" data-id="element-46"></div>
      <div className="max-w-7xl mx-auto px-6 relative" data-id="element-47">
        <div className="flex flex-col items-center gap-4 text-center" data-id="element-48">
          <div data-id="element-49">
            <p className="text-sm font-semibold text-cyan-300/80" data-id="element-50">
              Peptide Science Institute - A Division of the Institute of
              Scientific Augmentation
            </p>
          </div>
          <p className="text-xs text-slate-400 max-w-3xl leading-relaxed" data-id="element-51">
            <strong data-id="element-52">MEDICAL DISCLAIMER:</strong> The information on this site is
            for informational and educational purposes only, does not constitute
            medical advice, and does not establish any kind of patient-client
            relationship by the use of this website.
          </p>
          <div className="text-xs text-slate-500" data-id="element-53">
            <span data-id="element-54">Copyright © Peptide Science Institute</span>
            <span className="mx-2 text-fuchsia-500/30" data-id="element-55">|</span>
            <a href="https://peptidescienceinstitute.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-cyan-400 hover:underline transition-colors duration-300" data-id="element-56">
              Privacy Policy
            </a>
            <span className="mx-2 text-fuchsia-500/30" data-id="element-57">|</span>
            <a href="https://peptidescienceinstitute.com/terms-of-use" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-fuchsia-400 hover:underline transition-colors duration-300" data-id="element-58">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </footer>;
}